<template>
  <mdb-modal
    size="xl"
    :show="showModalTemplatesView"
    :centered="true"
    @close="close"
  >
    <mdb-modal-header>
      <mdb-modal-title>Visualizar Templates</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
      <div class="d-flex">
        <div class="w-100 d-flex flex-column align-items-center">
          <mdb-tbl responsive hover bordered class="w-100 text-center">
            <colgroup>
              <col />
              <col />
            </colgroup>
            <thead class="bg-color-table">
              <tr class="bg-color-table">
                <th class="text-white">Nome do template</th>
                <th class="text-white">Ação</th>
              </tr>
            </thead>
            <tbody v-if="data">
              <tr
                class="bordered"
                v-for="(item, index) in data.templatesSummaries"
                :key="index"
              >
                <td>
                  <span>{{ item.template_name }}</span>
                </td>
                <td class="d-flex align-items-center justify-content-center">
                  <mdb-btn
                    title="Visualizar"
                    type="button"
                    class="btn btn-blue btn-rounded m-0 ml-3 text-btn nowrap"
                    @click="
                      () => {
                        selectedTemplateBody = item.sample_text;
                        selectedTemplateButtons = item.sample_buttons;
                      }
                    "
                  >
                    <mdb-icon icon="eye" />Visualizar
                  </mdb-btn>
                </td>
              </tr>
            </tbody>
          </mdb-tbl>
        </div>
        <preview-template
          :selectedTemplateBody="selectedTemplateBody"
          :selectedTemplateButtons="selectedTemplateButtons"
          :loadingPreview="loadingPreview"
        />
      </div>
    </mdb-modal-body>
  </mdb-modal>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbTbl,
  mdbIcon,
  mdbBtn,
} from "mdbvue";
import PreviewTemplate from "../PreviewTemplate.vue";

export default {
  name: "ModalViewTemplates",
  props: ["showModalTemplatesView", "data"],
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbTbl,
    PreviewTemplate,
    mdbIcon,
    mdbBtn,
  },
  data() {
    return {
      loadingPreview: false,
      selectedTemplateBody: "",
      selectedTemplateButtons: [],
      collection: [{}],
    };
  },
  methods: {
    getTemplateBody(selectedTemplate) {
      this.loadingPreview = true;
      // // this.selectedTemplateBody = item.templatesSummaries[].body
      console.log(JSON.parse(JSON.stringify(selectedTemplate)));
      // this.selectedTemplateBody = selectedTemplate.sample_text;
      // this.selectedTemplateButtons = selectedTemplate.sample_buttons;
      console.log(JSON.parse(JSON.stringify(selectedTemplate.sample_buttons)));
      // this.loadingPreview = false;
    },
    close() {
      this.selectedTemplateBody = "";
      this.selectedTemplateButtons = [];
      this.$emit("input", "showModalTemplatesView", false);
    },
  },
};
</script>

<style scoped>
.text-btn {
  display: flex;
  align-content: center;
  flex-direction: row;
  justify-content: center;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 12pt;
  background-color: #3b85fc !important;
}
.nowrap {
  white-space: nowrap;
}
.text-btn i {
  margin-right: 1em;
  display: flex;
  align-self: center;
}
</style>